import { Navigate, Outlet } from "react-router-dom";
import { useOktaAuth } from "@okta/okta-react";
import { useVerifyAccess } from "../../useVerifyAccess";
import { AppPage } from "../Page/Page";

const ProtectedRoute = () => {
  const { authState } = useOktaAuth();
  const accessStatus = useVerifyAccess();

  if (!authState) {
    return <AppPage isLoading={true} />;
  }

  if (authState && !authState?.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (accessStatus !== 'verified') {
    return <AppPage isLoading={true} />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
